(function () {
  "use strict";

  // ─── Organizer Type → Pricing Tier mapping ────────────────────────────────────────
  // Maps Google Form organizer labels to the Shopify variant pricing tier keys.
  // Corporate Entity → Non-local Business pricing (confirm with client if needed).
  var ORG_TYPE_PRICING = {
    "Local Community Organizer / Non-Profit / Mutual Aid Fund": "Community",
    "Local For-Profit Small Business / Brand": "Local Business",
    "Non-Local Entity (Operating primarily outside of the selected city)":
      "Non-local Business",
    "Corporate Entity": "Non-local Business",
  };

  // ─── Price Map ──────────────────────────────────────────────────────────────
  // Populated at runtime by fetching the Shopify product's variant prices.
  // Key: variant ID (number) → Value: price in dollars (number)
  var priceMap = {};

  // ─── Variant Map ─────────────────────────────────────────────────────────────
  // Populated at runtime from the Shopify product API response.
  // Key: '{MARKET}|{TIER}|{TYPE}' → Value: variant ID (number)
  var variantMap = {};
  // ID of the 'Free Submission' variant; 0 until fetch resolves.
  var freeVariantId = 0;
  // Set to true when the final product fetch (post-retry) fails.
  var fetchFailed = false;

  function setFreeSubmitReady(ready) {
    var btn = id("sc-btn-free-submit");
    if (!btn) return;
    btn.disabled = !ready;
    btn.textContent = ready ? "Submit Free Event" : "Loading…";
  }

  function fetchProductPrices(isRetry) {
    var cfg = window.scConfig || {};
    var handle = cfg.productHandle;
    if (!handle) return;
    fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (res) {
        return res.json();
      })
      .then(function (product) {
        (product.variants || []).forEach(function (v) {
          priceMap[v.id] = v.price / 100;

          if (v.title === 'Free Submission') {
            freeVariantId = v.id;
          } else {
            var parts = v.title.split(' - ');
            if (parts.length === 3) {
              var key = parts[0].trim() + '|' + parts[1].trim() + '|' + parts[2].trim();
              variantMap[key] = v.id;
            } else {
              console.warn('[SponsoredContent] Unmatched variant title:', v.title);
            }
          }
        });
        fetchFailed = false;
        setFreeSubmitReady(!!freeVariantId);
        updatePriceDisplay();
      })
      .catch(function (err) {
        console.warn("[SponsoredContent] Could not fetch product prices:", err);
        if (!isRetry) {
          setTimeout(function () { fetchProductPrices(true); }, 3000);
        } else {
          fetchFailed = true;
          setFreeSubmitReady(false);
          updatePriceDisplay();
        }
      });
  }

  // ─── State ─────────────────────────────────────────────────────────────────
  var state = {
    submissionType: "free",
    orgType: "",
    selectedItems: [], // [{type, qty}]
    market: "",
    contactName: "",
    contactEmail: "",
    eventName: "",
    eventDate: "",
    venueAddress: "",
    organizedBy: "",
    eventDescription: "",
    ticketLink: "",
    instagramAccount: "",
    orgConnection: "",
    audienceFor: [],
    eventIsFree: "",
    // Multi-slot booking: one Calendly booking per unit of qty
    // slots: [{type}] — flat list expanded from selectedItems
    // calendlyBookings: [{type, uri}] — filled as user books each slot
    slots: [],
    currentSlotIndex: 0,
    calendlyBookings: [],
    price: 0,
  };

  // Build flat slot list from selectedItems (Photo×2 → 2 entries)
  function buildSlots() {
    state.slots = [];
    state.selectedItems.forEach(function (item) {
      for (var i = 0; i < item.qty; i++) {
        state.slots.push({ type: item.type });
      }
    });
    state.currentSlotIndex = 0;
    state.calendlyBookings = [];
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────
  function id(str) {
    return document.getElementById(str);
  }

  function getMarketLabel(market) {
    var labels = {
      LA: "Los Angeles (LA)",
      NYC: "New York City (NYC)",
      SF: "San Francisco (SF)",
    };

    return labels[market] || market;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // Catch common typos for major email providers so users don't silently
  // submit unreachable addresses.
  var EMAIL_DOMAIN_TYPOS = {
    "gmial.com": "gmail.com",
    "gmal.com": "gmail.com",
    "gmail.co": "gmail.com",
    "gnail.com": "gmail.com",
    "yaho.com": "yahoo.com",
    "yhoo.com": "yahoo.com",
    "yahoo.co": "yahoo.com",
    "hotmial.com": "hotmail.com",
    "hotnail.com": "hotmail.com",
    "outloo.com": "outlook.com",
    "outlok.com": "outlook.com",
  };

  function getEmailTypoSuggestion(email) {
    var parts = email.toLowerCase().split("@");
    if (parts.length !== 2) return "";
    var fix = EMAIL_DOMAIN_TYPOS[parts[1]];
    return fix ? parts[0] + "@" + fix : "";
  }

  // Strip URL prefixes / leading @ so we always store a clean @handle.
  function normalizeInstagram(value) {
    if (!value) return "";
    var v = value.trim();
    v = v.replace(/^https?:\/\/(www\.)?instagram\.com\//i, "");
    v = v.replace(/^@+/, "");
    v = v.replace(/\/.*$/, "");
    v = v.replace(/[^A-Za-z0-9._]/g, "");
    return v ? "@" + v : "";
  }

  // ─── State persistence (localStorage) ─────────────────────────────────────
  // Keeps the form populated if the user accidentally reloads the page.
  // We deliberately skip file uploads (can't serialize) and Calendly state
  // (URIs would point at past bookings).
  var STORAGE_KEY = "sc-form-state-v1";
  var PERSIST_KEYS = [
    "submissionType", "orgType", "selectedItems", "market",
    "contactName", "contactEmail", "eventName", "eventDate",
    "venueAddress", "organizedBy", "eventDescription", "ticketLink",
    "instagramAccount", "orgConnection", "audienceFor", "eventIsFree",
  ];
  var persistTimer = null;

  function saveStateSoon() {
    if (persistTimer) clearTimeout(persistTimer);
    persistTimer = setTimeout(function () {
      try {
        var snap = {};
        PERSIST_KEYS.forEach(function (k) { snap[k] = state[k]; });
        localStorage.setItem(STORAGE_KEY, JSON.stringify(snap));
      } catch (_) { /* quota exceeded or private mode — silently ignore */ }
    }, 400);
  }

  function clearSavedState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  }

  // Lock all inputs in step 1 while a submission is in flight so the user
  // can't change fields or double-click submit.
  function setFormDisabled(disabled) {
    var form = id("sc-details-form");
    if (!form) return;
    form.classList.toggle("sc-form-disabled", disabled);
    var fields = form.querySelectorAll("input, select, textarea, button");
    fields.forEach(function (el) {
      // Skip the Submit button itself; the caller manages its label/state.
      if (el.id === "sc-btn-free-submit" || el.id === "sc-btn-to-schedule") return;
      if (disabled) {
        if (!el.disabled) el.dataset.scWasEnabled = "1";
        el.disabled = true;
      } else if (el.dataset.scWasEnabled === "1") {
        el.disabled = false;
        delete el.dataset.scWasEnabled;
      }
    });
  }

  // ─── Step Management ────────────────────────────────────────────────────────
  var FREE_SUCCESS_STEP = 99;

  var PANELS = {
    1: "sc-step-1",
    2: "sc-step-2",
    3: "sc-step-3",
    99: "sc-free-success",
  };

  function showStep(num) {
    Object.keys(PANELS).forEach(function (k) {
      var el = id(PANELS[k]);
      if (el) el.style.display = "none";
    });

    var target = id(PANELS[num]);
    if (target) target.style.display = "block";

    // Update step indicator
    var indicator = id("sc-steps-indicator");
    if (indicator) {
      indicator.style.display =
        state.submissionType === "free" || num === FREE_SUCCESS_STEP ? "none" : "flex";
      indicator.querySelectorAll(".sc-step-item").forEach(function (item) {
        var s = parseInt(item.dataset.step, 10);
        item.classList.toggle("active", s === num);
        item.classList.toggle("completed", s < num);
      });
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  // ─── Pricing ────────────────────────────────────────────────────────────────
  function getVariantIdForType(contentType) {
    var pricingTier = ORG_TYPE_PRICING[state.orgType] || state.orgType;
    var key = state.market + "|" + pricingTier + "|" + contentType;
    return variantMap[key] || 0;
  }

  function calculateTotalPrice() {
    var total = 0;
    state.selectedItems.forEach(function (item) {
      var variantId = getVariantIdForType(item.type);
      var unitPrice = variantId ? priceMap[variantId] || 0 : 0;
      total += unitPrice * item.qty;
    });
    return total;
  }

  function updatePriceDisplay() {
    var priceEl = id("sc-price-display");
    var noteEl = id("sc-pricing-note");

    // Update per-row prices inside the content type list
    document
      .querySelectorAll("#sc-content-type-list .sc-ct-row")
      .forEach(function (row) {
        var type = row.dataset.type;
        var priceSpan = row.querySelector(".sc-ct-price");
        var qtyInput = row.querySelector(".sc-qty-input");
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (!priceSpan) return;
        if (!state.orgType || !state.market) {
          priceSpan.textContent = "—";
          return;
        }
        var variantId = getVariantIdForType(type);
        var unitPrice = variantId ? (priceMap[variantId] != null ? priceMap[variantId] : null) : null;
        if (unitPrice !== null && unitPrice > 0) {
          priceSpan.textContent = "$" + (unitPrice * qty).toFixed(2);
        } else if (unitPrice === 0 && variantId) {
          priceSpan.textContent = "$0.00";
        } else if (!variantId || fetchFailed) {
          priceSpan.textContent = "—";
        } else {
          priceSpan.textContent = "Loading…";
        }
      });

    if (!priceEl) return;

    if (!state.orgType || !state.market) {
      priceEl.textContent = "—";
      if (noteEl) {
        noteEl.textContent = "Select city and organizer type to see pricing.";
        noteEl.style.display = "block";
      }
      state.price = 0;
      return;
    }

    if (!state.selectedItems.length) {
      priceEl.textContent = "—";
      if (noteEl) {
        noteEl.textContent =
          "Select at least one content type above to see pricing.";
        noteEl.style.display = "block";
      }
      state.price = 0;
      return;
    }

    var total = calculateTotalPrice();
    state.price = total;

    if (total > 0) {
      priceEl.textContent = "$" + total.toFixed(2);
      if (noteEl) noteEl.style.display = "none";
    } else {
      priceEl.textContent = "—";
      if (noteEl) {
        noteEl.textContent = "Pricing loading…";
        noteEl.style.display = "block";
      }
    }
  }

  function updateSubmissionTypeUI() {
    var isFree = state.submissionType === "free";

    document.querySelectorAll(".sc-sponsored-only").forEach(function (el) {
      el.style.display = isFree ? "none" : "block";
    });

    var btnSchedule = id("sc-btn-to-schedule");
    var btnFreeSubmit = id("sc-btn-free-submit");
    var freeHint = document.querySelector(".sc-free-hint");

    if (btnSchedule) btnSchedule.style.display = isFree ? "none" : "";
    if (btnFreeSubmit) btnFreeSubmit.style.display = isFree ? "" : "none";
    if (freeHint) freeHint.style.display = isFree ? "" : "none";

    // When switching to free, clear sponsored-only state so stale selections
    // don't leak into validation or pricing.
    if (isFree) {
      state.selectedItems = [];
      state.slots = [];
      state.currentSlotIndex = 0;
      state.calendlyBookings = [];
    }
  }

  // ─── Validation ─────────────────────────────────────────────────────────────
  // Returns [{ field: elementId, msg: string }] so each error can both highlight
  // a field and appear in the summary list.
  function validateStep1() {
    var errors = [];
    function add(field, msg) { errors.push({ field: field, msg: msg }); }

    if (!state.contactName.trim()) add("sc-contact-name", "Please enter your name.");
    if (!state.contactEmail.trim() || !isValidEmail(state.contactEmail)) {
      add("sc-contact-email", "Please enter a valid email address.");
    }
    if (!state.eventName.trim()) add("sc-event-name", "Please enter the event name.");
    if (!state.eventDate) {
      add("sc-event-date", "Please select the event date.");
    } else {
      // Block past dates even if the browser doesn't enforce the min attribute
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var picked = new Date(state.eventDate + "T00:00:00");
      if (picked < today) add("sc-event-date", "Event date cannot be in the past.");
    }
    if (!state.eventIsFree) add("sc-event-is-free-group", "Please indicate if this event is free for attendees.");
    if (!state.venueAddress.trim()) add("sc-venue-address", "Please enter the venue address.");
    if (!state.organizedBy.trim()) add("sc-organized-by", "Please enter who is organizing this event.");
    if (!state.eventDescription.trim()) add("sc-event-description", "Please enter a brief event description.");
    if (!state.ticketLink.trim()) add("sc-ticket-link", "Please enter the ticket link or event page URL.");
    if (!state.orgType) add("sc-org-type-group", "Please select an organizer type.");
    if (!state.orgConnection.trim()) add("sc-org-connection", "Please describe your connection to the Sapphic community.");
    if (!state.audienceFor.length) add("sc-audience-checkboxes", "Please select at least one audience option.");
    if (!state.market) add("sc-market", "Please select a market (LA, NYC, or SF).");
    if (state.submissionType === "sponsored") {
      var mediaInput = id("sc-media-upload");
      if (!mediaInput || !mediaInput.files || !mediaInput.files.length) {
        add("sc-upload-box", "Please upload your media file (flyer, image, or video).");
      }
      if (!state.selectedItems.length) {
        add("sc-content-type-list", "Please select at least one content type for your sponsored submission.");
      }
    }
    return errors;
  }

  function clearFieldErrors() {
    document.querySelectorAll(".sc-field-invalid").forEach(function (el) {
      el.classList.remove("sc-field-invalid");
    });
  }

  function highlightInvalidField(fieldId) {
    var el = id(fieldId);
    if (el) el.classList.add("sc-field-invalid");
  }

  function showStep1Errors(errors) {
    var el = id("sc-step1-errors");
    clearFieldErrors();
    if (!el) return;
    el.innerHTML = "";
    if (!errors.length) { el.style.display = "none"; return; }

    errors.forEach(function (err) {
      var msg = typeof err === "string" ? err : err.msg;
      if (typeof err === "object" && err.field) highlightInvalidField(err.field);
      var p = document.createElement("p");
      p.textContent = msg;
      el.appendChild(p);
    });
    el.style.display = "block";
    el.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  // ─── Calendly ───────────────────────────────────────────────────────────────
  var calendlyLoaded = false;

  function loadCalendly() {
    var container = id("sc-calendly-widget");
    var loading = id("sc-calendly-loading");
    if (!container) return;

    var cfg = window.scConfig || {};
    var calendlyUrls = {
      LA: cfg.calendlyLaUrl || "",
      NYC: cfg.calendlyNycUrl || "",
      SF: cfg.calendlySfUrl || "",
    };
    var baseUrl = calendlyUrls[state.market] || "";

    if (!baseUrl) {
      if (loading)
        loading.innerHTML =
          '<p class="sc-calendly-error">Scheduling calendar is not configured yet. Please contact us directly to book your date.</p>';
      return;
    }

    // Update slot progress heading and subtitle
    var total = state.slots.length;
    var current = state.currentSlotIndex + 1;
    var currentType = (state.slots[state.currentSlotIndex] || {}).type || "";

    var heading = id("sc-schedule-heading");
    if (heading) {
      heading.textContent =
        total > 1
          ? "Booking slot " + current + " of " + total + " — " + currentType
          : "Choose Your Posting Date";
    }

    var subtitle = id("sc-schedule-subtitle");
    if (subtitle) {
      var timezoneNotes = {
        LA: "Slots are shown in Pacific Time (PT).",
        NYC: "Slots are shown in Eastern Time (ET).",
        SF: "Slots are shown in Pacific Time (PT).",
      };
      var tzNote = timezoneNotes[state.market] || "";
      var isPriority = currentType === "Priority Placement";
      if (isPriority) {
        subtitle.innerHTML =
          tzNote +
          " <strong>For Priority Newsletter Listing: select the 12:00 AM slot for the day of your event.</strong>";
      } else {
        subtitle.textContent = tzNote + " Select any slot other than 12:00 AM.";
      }
    }

    // Build URL — prefill contact details in Calendly
    // Use encodeURIComponent (not URLSearchParams) so spaces become %20 not +
    var queryParts = [
      "name=" + encodeURIComponent(state.contactName),
      "email=" + encodeURIComponent(state.contactEmail),
      "a1=" + encodeURIComponent(state.eventName),
      "hide_gdpr_banner=1",
    ];
    var fullUrl =
      baseUrl +
      (baseUrl.indexOf("?") === -1 ? "?" : "&") +
      queryParts.join("&");

    container.setAttribute("data-url", fullUrl);

    if (calendlyLoaded && window.Calendly) {
      // Re-initialise with new URL (e.g. market changed)
      container.innerHTML = "";
      container.style.display = "block";
      if (loading) loading.style.display = "none";
      window.Calendly.initInlineWidget({
        url: fullUrl,
        parentElement: container,
      });
      return;
    }

    // First load — inject Calendly script only if not already present
    if (!document.querySelector('script[src*="calendly.com"]')) {
      var script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.onload = function () {
        calendlyLoaded = true;
        container.style.display = "block";
        if (loading) loading.style.display = "none";
        if (window.Calendly) {
          window.Calendly.initInlineWidget({
            url: fullUrl,
            parentElement: container,
          });
        }
      };
      script.onerror = function () {
        if (loading)
          loading.innerHTML =
            '<p class="sc-calendly-error">Failed to load scheduling calendar. Please try refreshing the page.</p>';
      };
      document.head.appendChild(script);
    } else if (window.Calendly) {
      // Script already in DOM (e.g. onload raced back-navigation) — init directly
      calendlyLoaded = true;
      container.style.display = "block";
      if (loading) loading.style.display = "none";
      window.Calendly.initInlineWidget({
        url: fullUrl,
        parentElement: container,
      });
    } else {
      // Script in DOM but not yet loaded — poll until ready
      var waitInterval = setInterval(function () {
        if (window.Calendly) {
          clearInterval(waitInterval);
          calendlyLoaded = true;
          container.style.display = "block";
          if (loading) loading.style.display = "none";
          window.Calendly.initInlineWidget({ url: fullUrl, parentElement: container });
        }
      }, 100);
      // If Calendly never loads within 10s, surface an error instead of leaving the spinner
      setTimeout(function () {
        clearInterval(waitInterval);
        if (!window.Calendly && loading) {
          loading.innerHTML =
            '<p class="sc-calendly-error">Scheduling calendar took too long to load. Please refresh the page.</p>';
        }
      }, 10000);
    }
  }

  // Listen for Calendly postMessage events
  window.addEventListener("message", function (e) {
    // Reject messages not originating from Calendly
    if (e.origin !== "https://calendly.com") return;
    if (!e.data || typeof e.data.event !== "string") return;
    if (e.data.event.indexOf("calendly") !== 0) return;

    if (e.data.event === "calendly.event_scheduled") {
      var payload = e.data.payload || {};
      var uri = (payload.event && payload.event.uri) || "";

      // Record this booking
      state.calendlyBookings[state.currentSlotIndex] = {
        type: (state.slots[state.currentSlotIndex] || {}).type || "",
        uri: uri,
      };

      var total = state.slots.length;
      var nextIndex = state.currentSlotIndex + 1;

      var statusEl = id("sc-schedule-status");

      if (nextIndex < total) {
        // More slots to book — advance to next
        state.currentSlotIndex = nextIndex;

        if (statusEl) {
          statusEl.innerHTML =
            '<div class="sc-status-success">✓ Slot ' +
            nextIndex +
            " of " +
            total +
            " booked! Loading next slot…</div>";
          statusEl.style.display = "block";
        }

        setTimeout(function () {
          if (statusEl) statusEl.style.display = "none";
          loadCalendly();
        }, 1600);
      } else {
        // All slots booked
        if (statusEl) {
          statusEl.innerHTML =
            '<div class="sc-status-success">✓ All ' +
            total +
            " slots booked! Ready to review.</div>";
          statusEl.style.display = "block";
        }

        var continueBtn = id("sc-btn-continue-to-review");
        if (continueBtn) continueBtn.style.display = "";

        setTimeout(function () {
          populateReview();
          showStep(3);
        }, 1600);
      }
    }
  });

  // ─── Review Panel ────────────────────────────────────────────────────────────
  function populateReview() {
    function set(elId, val) {
      var el = id(elId);
      if (el) el.textContent = val || "—";
    }
    set("rv-contact", state.contactName + " · " + state.contactEmail);
    set("rv-event-name", state.eventName);
    set("rv-event-date", state.eventDate);
    set("rv-venue", state.venueAddress);
    set("rv-org-type", state.orgType);
    set("rv-market", getMarketLabel(state.market));
    var contentEl = id("rv-content-items");
    if (contentEl) {
      if (!state.selectedItems.length) {
        contentEl.textContent = "—";
      } else {
        contentEl.innerHTML = "";
        state.selectedItems.forEach(function (item) {
          var variantId = getVariantIdForType(item.type);
          var unitPrice = variantId ? priceMap[variantId] || 0 : 0;
          var lineTotal = unitPrice * item.qty;
          var qtyStr = item.qty > 1 ? " × " + item.qty : "";
          var priceStr = unitPrice > 0 ? " — $" + lineTotal.toFixed(2) : "";
          var div = document.createElement("div");
          div.className = "rv-item";
          div.textContent = item.type + qtyStr + priceStr;
          contentEl.appendChild(div);
        });
      }
    }
    // Posting dates — show each booked slot
    var postingEl = id("rv-posting-date");
    if (postingEl) {
      if (state.calendlyBookings.length === 0) {
        postingEl.textContent = "—";
      } else if (state.calendlyBookings.length === 1) {
        postingEl.textContent = "Confirmed via Calendly (see order notes)";
      } else {
        postingEl.innerHTML = "";
        state.calendlyBookings.forEach(function (b, i) {
          var div = document.createElement("div");
          div.className = "rv-item";
          div.textContent = "Slot " + (i + 1) + " (" + b.type + "): Confirmed via Calendly";
          postingEl.appendChild(div);
        });
      }
    }

    set("rv-total-price", state.price ? "$" + state.price.toFixed(2) : "—");
  }

  // ─── Cart & Checkout ─────────────────────────────────────────────────────────
  function addToCartAndCheckout() {
    if (!state.selectedItems.length) {
      showCheckoutError("No content types selected.");
      return;
    }

    var btn = id("sc-btn-checkout");
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Processing…";
    }

    // Build posting date summary from all booked slots
    var postingSummary =
      state.calendlyBookings.length > 0
        ? state.calendlyBookings
            .map(function (b, i) {
              return "Slot " + (i + 1) + " (" + b.type + "): see Calendly";
            })
            .join(" | ")
        : "—";

    var baseProperties = {
      "Submission Type": "Sponsored Content",
      "Contact Name": state.contactName,
      "Contact Email": state.contactEmail,
      "Event Name": state.eventName,
      "Event Date": state.eventDate,
      "Venue Address": state.venueAddress,
      "Organized By": state.organizedBy,
      "Event Description": state.eventDescription,
      "Ticket Link": state.ticketLink,
      "Instagram Account": state.instagramAccount || "—",
      "Organizer Type": state.orgType,
      "Sapphic Connection": state.orgConnection,
      Audience: state.audienceFor.join(", ") || "—",
      "Is Event Free": state.eventIsFree || "—",
      City: getMarketLabel(state.market),
      "Posting Date": postingSummary,
      "Booking Type": "Sponsored Content",
    };

    // Attach each Calendly booking URI individually
    state.calendlyBookings.forEach(function (b, i) {
      baseProperties["_Calendly Slot " + (i + 1)] = b.uri;
    });

    var items = state.selectedItems.map(function (item) {
      var variantId = getVariantIdForType(item.type);
      var props = {};
      Object.keys(baseProperties).forEach(function (k) {
        props[k] = baseProperties[k];
      });
      props["Content Type"] = item.type;
      return { id: variantId, quantity: item.qty, properties: props };
    });

    var unconfigured = items.filter(function (i) {
      return !i.id;
    });
    if (unconfigured.length) {
      showCheckoutError(
        "Could not find a matching product variant. Please try refreshing the page, or contact us if the problem persists.",
      );
      if (btn) {
        btn.disabled = false;
        btn.textContent = "Proceed to Checkout →";
      }
      return;
    }

    var mediaFile =
      (id("sc-media-upload") || {}).files && id("sc-media-upload").files[0];

    // Note: previously called /cart/clear.js first, but it triggers Shopify's bot
    // protection inconsistently and returns 403. /cart/add.js works without clearing.
    Promise.resolve()
      .then(function () {
        // Add items sequentially — FormData (with file) for first item, JSON for the rest
        // Shopify's /cart/add.js does not support items[] array format with FormData
        function addItem(index) {
          if (index >= items.length) return Promise.resolve();
          var item = items[index];
          var isFirst = index === 0;

          function doFetch(attempt) {
            var req;
            if (isFirst && mediaFile) {
              var formData = new FormData();
              formData.append("id", item.id);
              formData.append("quantity", item.quantity);
              Object.keys(item.properties).forEach(function (k) {
                formData.append("properties[" + k + "]", item.properties[k]);
              });
              formData.append("properties[Media]", mediaFile, mediaFile.name);
              req = fetch("/cart/add.js", { method: "POST", body: formData, headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" } });
            } else {
              var props = Object.assign({}, item.properties);
              req = fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" },
                body: JSON.stringify({
                  items: [{ id: item.id, quantity: item.quantity, properties: props }],
                }),
              });
            }
            return req.then(function (res) {
              if (!res.ok) {
                if (res.status === 403 && attempt < 2) {
                  return new Promise(function (resolve) { setTimeout(resolve, 1000); })
                    .then(function () { return doFetch(attempt + 1); });
                }
                return res.text().then(function (text) {
                  var msg = "Could not add to cart (HTTP " + res.status + ").";
                  try { var e = JSON.parse(text); if (e.description) msg = e.description; } catch (_) {}
                  console.error("[SponsoredContent] cart/add.js " + res.status + " body:", text);
                  throw new Error(msg);
                });
              }
              return addItem(index + 1);
            });
          }
          return doFetch(0);
        }
        return addItem(0);
      })
      .then(function () {
        var uris = state.calendlyBookings.map(function (b) { return b.uri; }).join(",");
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ note: uris }),
        }).then(function (res) {
          if (!res.ok) throw new Error("Failed to save booking reference (HTTP " + res.status + ")");
        });
      })
      .then(function () {
        clearSavedState();
        window.location.href = "/checkout";
      })
      .catch(function (err) {
        console.error("[SponsoredContent] cart error:", err);
        showCheckoutError(
          "There was a problem preparing your checkout: " + err.message,
        );
        if (btn) {
          btn.disabled = false;
          btn.textContent = "Proceed to Checkout →";
        }
      });
  }

  function showCheckoutError(msg) {
    var el = id("sc-checkout-error");
    if (el) {
      el.textContent = msg;
      el.style.display = "block";
    }
  }

  // ─── Free Submission ─────────────────────────────────────────────────────────
  function submitFreeEvent() {
    var errors = validateStep1();
    if (errors.length) {
      showStep1Errors(errors);
      return;
    }
    showStep1Errors([]);

    if (!freeVariantId) {
      showStep1Errors([
        "Free submission variant could not be found. Please refresh and try again, or contact us directly.",
      ]);
      return;
    }

    var btn = id("sc-btn-free-submit");
    if (btn) {
      btn.disabled = true;
      btn.textContent = "Submitting…";
    }
    setFormDisabled(true);

    var properties = {
      "Submission Type": "Free Submission",
      "Contact Name": state.contactName,
      "Contact Email": state.contactEmail,
      "Event Name": state.eventName,
      "Event Date": state.eventDate,
      "Venue Address": state.venueAddress,
      "Organized By": state.organizedBy,
      "Event Description": state.eventDescription,
      "Ticket Link": state.ticketLink,
      "Instagram Account": state.instagramAccount || "—",
      "Organizer Type": state.orgType,
      "Sapphic Connection": state.orgConnection,
      Audience: state.audienceFor.join(", ") || "—",
      "Is Event Free": state.eventIsFree || "—",
      Market: state.market || "—",
    };

    var mediaFile =
      (id("sc-media-upload") || {}).files && id("sc-media-upload").files[0];

    // Note: previously called /cart/clear.js first, but it triggers Shopify's bot
    // protection inconsistently and returns 403. /cart/add.js works without clearing.
    Promise.resolve()
      .then(function () {
        // Build FormData inside doFreeAdd so each retry sends a fresh body.
        // Reusing a single FormData across fetches sends an empty body on retry.
        function buildFormData() {
          var fd = new FormData();
          fd.append("id", freeVariantId);
          fd.append("quantity", 1);
          Object.keys(properties).forEach(function (k) {
            fd.append("properties[" + k + "]", properties[k]);
          });
          if (mediaFile) {
            fd.append("properties[Media]", mediaFile, mediaFile.name);
          }
          return fd;
        }
        function doFreeAdd(attempt) {
          return fetch("/cart/add.js", { method: "POST", body: buildFormData(), headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" } })
            .then(function (res) {
              if (!res.ok) {
                if (res.status === 403 && attempt < 2) {
                  return new Promise(function (resolve) { setTimeout(resolve, 1000); })
                    .then(function () { return doFreeAdd(attempt + 1); });
                }
                return res.text().then(function (text) {
                  var msg = "Could not submit (HTTP " + res.status + "). The free submission product may need to be reconfigured — please contact the site admin.";
                  try { var e = JSON.parse(text); if (e.description) msg = e.description; } catch (_) {}
                  console.error("[SponsoredContent] free cart/add.js " + res.status + " body:", text);
                  throw new Error(msg);
                });
              }
              // $0 checkout — Shopify skips payment and creates the order immediately.
              // Shopify Flow should auto-tag the order "Free Submission".
              // Briefly show the success panel so the user gets confirmation before
              // Shopify's checkout page takes over.
              clearSavedState();
              showStep(FREE_SUCCESS_STEP);
              var redirectNote = id("sc-free-redirect-note");
              if (redirectNote) redirectNote.style.display = "block";
              setTimeout(function () {
                window.location.href = "/checkout";
              }, 1500);
            });
        }
        return doFreeAdd(0);
      })
      .catch(function (err) {
        console.error("[SponsoredContent] free submit error:", err);
        setFormDisabled(false);
        showStep1Errors([
          { msg: "Something went wrong: " + err.message + " Please try again." },
        ]);
        if (btn) {
          btn.disabled = false;
          btn.textContent = "Submit Free Event";
        }
      });
  }

  // ─── Event Wiring ────────────────────────────────────────────────────────────
  function syncField(elId, stateKey) {
    var el = id(elId);
    if (!el) return;
    function update(e) {
      state[stateKey] = e.target.value;
      if (stateKey === "orgType" || stateKey === "market") updatePriceDisplay();
      // As the user fixes a field, drop its invalid styling so they get feedback
      e.target.classList.remove("sc-field-invalid");
      saveStateSoon();
    }
    el.addEventListener("input", update);
    el.addEventListener("change", update);
  }

  function updateDescriptionCounter() {
    var input = id("sc-event-description");
    var counter = id("sc-desc-counter");
    if (!input || !counter) return;
    var len = (input.value || "").length;
    var max = parseInt(input.getAttribute("maxlength") || "500", 10);
    counter.textContent = len + " / " + max;
    counter.classList.toggle("sc-counter-warn", len >= max * 0.9);
  }

  function updateEventDateHint() {
    var input = id("sc-event-date");
    var hint = id("sc-event-date-hint");
    if (!input || !hint) return;
    if (!input.value) { hint.style.display = "none"; return; }
    var d = new Date(input.value + "T00:00:00");
    var day = d.getDay(); // 0=Sun, 6=Sat
    if (day === 0 || day === 6) {
      hint.textContent = "Heads up: weekend events are only visible to paid newsletter subscribers.";
      hint.style.display = "block";
    } else {
      hint.style.display = "none";
    }
  }

  function showEmailTypoSuggestion() {
    var input = id("sc-contact-email");
    if (!input) return;
    var existing = id("sc-email-typo-suggestion");
    if (existing) existing.remove();
    var suggestion = getEmailTypoSuggestion(input.value);
    if (!suggestion) return;
    var p = document.createElement("p");
    p.id = "sc-email-typo-suggestion";
    p.className = "sc-field-hint sc-typo-suggestion";
    p.innerHTML = 'Did you mean <button type="button" class="sc-typo-fix">' + suggestion + '</button>?';
    input.parentNode.appendChild(p);
    p.querySelector(".sc-typo-fix").addEventListener("click", function () {
      input.value = suggestion;
      state.contactEmail = suggestion;
      p.remove();
      saveStateSoon();
    });
  }

  function init() {
    // Submission type radios
    document
      .querySelectorAll('input[name="submission_type"]')
      .forEach(function (radio) {
        radio.addEventListener("change", function (e) {
          state.submissionType = e.target.value;
          updateSubmissionTypeUI();
          updatePriceDisplay();
        });
      });

    // Sync form fields to state
    syncField("sc-contact-name", "contactName");
    syncField("sc-contact-email", "contactEmail");
    syncField("sc-event-name", "eventName");
    syncField("sc-event-date", "eventDate");
    syncField("sc-venue-address", "venueAddress");
    syncField("sc-organized-by", "organizedBy");
    syncField("sc-event-description", "eventDescription");
    syncField("sc-ticket-link", "ticketLink");
    syncField("sc-instagram-account", "instagramAccount");
    syncField("sc-org-connection", "orgConnection");
    syncField("sc-market", "market");

    // ─── Drag & Drop Upload ─────────────────────────────────────────────────────

    var uploadBox = id("sc-upload-box");

    var mediaInput = id("sc-media-upload");

    var preview = id("sc-preview");

    var uploadContent =
      uploadBox && uploadBox.querySelector(".sc-upload-content");

    var maxSize = 20 * 1024 * 1024; // 20 MB
    var ALLOWED_TYPES = ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/quicktime"];
    var currentFileURL = null;

    function clearUpload() {
      if (currentFileURL) { URL.revokeObjectURL(currentFileURL); currentFileURL = null; }
      if (mediaInput) mediaInput.value = "";
      if (preview) {
        preview.innerHTML = "";
        preview.classList.add("hidden");
      }
      if (uploadContent) uploadContent.style.display = "";
    }

    function handleUploadFile(file) {
      if (!file) return;

      if (!ALLOWED_TYPES.includes(file.type)) {
        alert("Unsupported file type. Please upload JPG, PNG, GIF, MP4, or MOV.");
        clearUpload();
        return;
      }

      if (file.size > maxSize) {
        alert("File must be under 20MB.");

        clearUpload();

        return;
      }

      // Hide the "Click to upload / drag and drop" text

      if (uploadContent) uploadContent.style.display = "none";

      preview.innerHTML = "";

      preview.classList.remove("hidden");

      // Build preview wrapper with X button

      var wrapper = document.createElement("div");

      wrapper.style.cssText = "position:relative;display:inline-block;";

      if (currentFileURL) { URL.revokeObjectURL(currentFileURL); }
      currentFileURL = URL.createObjectURL(file);
      var fileURL = currentFileURL;

      if (file.type.startsWith("image/")) {
        var img = document.createElement("img");

        img.src = fileURL;

        wrapper.appendChild(img);
      } else if (file.type.startsWith("video/")) {
        var vid = document.createElement("video");

        vid.src = fileURL;

        vid.controls = true;

        wrapper.appendChild(vid);
      } else {
        var p = document.createElement("p");

        p.textContent = "📎 " + file.name;

        wrapper.appendChild(p);
      }

      // X remove button

      var removeBtn = document.createElement("button");

      removeBtn.type = "button";

      removeBtn.textContent = "×";

      removeBtn.setAttribute("aria-label", "Remove file");

      removeBtn.style.cssText = [
        "position:absolute",

        "top:-8px",

        "right:-8px",

        "width:22px",

        "height:22px",

        "border-radius:50%",

        "border:none",

        "background:#222",

        "color:#fff",

        "font-size:14px",

        "line-height:1",

        "cursor:pointer",

        "display:flex",

        "align-items:center",

        "justify-content:center",

        "z-index:10",
      ].join(";");

      removeBtn.addEventListener("click", function (e) {
        e.stopPropagation(); // don't re-trigger the uploadBox click

        clearUpload();
      });

      wrapper.appendChild(removeBtn);

      preview.appendChild(wrapper);
    }

    if (uploadBox && mediaInput) {
      uploadBox.addEventListener("click", function () {
        mediaInput.click();
      });

      mediaInput.addEventListener("change", function () {
        handleUploadFile(this.files[0]);
      });

      uploadBox.addEventListener("dragover", function (e) {
        e.preventDefault();

        uploadBox.classList.add("dragover");
      });

      uploadBox.addEventListener("dragleave", function () {
        uploadBox.classList.remove("dragover");
      });

      uploadBox.addEventListener("drop", function (e) {
        e.preventDefault();

        uploadBox.classList.remove("dragover");

        var file = e.dataTransfer.files[0];

        mediaInput.files = e.dataTransfer.files;

        handleUploadFile(file);
      });
    }

    // ─── End Drag & Drop ────────────────────────────────────────────────────────

    // Is event free? radios
    document
      .querySelectorAll('input[name="event_is_free"]')
      .forEach(function (radio) {
        radio.addEventListener("change", function (e) {
          state.eventIsFree = e.target.value;
        });
      });

    // Content type checkboxes + quantity controls
    document
      .querySelectorAll("#sc-content-type-list .sc-ct-row")
      .forEach(function (row) {
        var checkbox = row.querySelector('input[type="checkbox"]');
        var qtyDiv = row.querySelector(".sc-ct-qty");
        var qtyInput = row.querySelector(".sc-qty-input");

        function syncItems() {
          state.selectedItems = [];
          document
            .querySelectorAll("#sc-content-type-list .sc-ct-row")
            .forEach(function (r) {
              var cb = r.querySelector('input[type="checkbox"]');
              var qi = r.querySelector(".sc-qty-input");
              if (cb && cb.checked) {
                state.selectedItems.push({
                  type: r.dataset.type,
                  qty: qi ? Math.min(Math.max(parseInt(qi.value, 10) || 1, 1), 10) : 1,
                });
              }
            });
          updatePriceDisplay();
        }

        if (checkbox) {
          checkbox.addEventListener("change", function () {
            if (qtyDiv) qtyDiv.style.display = checkbox.checked ? "" : "none";
            if (!checkbox.checked && qtyInput) qtyInput.value = 1;
            syncItems();
          });
        }

        if (qtyInput) {
          function clampQty() {
            if (row.dataset.type === "Priority Placement") {
              qtyInput.value = 1;
              return;
            }
            var v = parseInt(qtyInput.value, 10);
            if (isNaN(v) || v < 1) qtyInput.value = 1;
            else if (v > 10) qtyInput.value = 10;
          }
          // Validate live on input so the user gets immediate feedback
          // instead of typing "999" and only seeing 10 after blur.
          qtyInput.addEventListener("input", function () {
            clampQty();
            syncItems();
          });
          qtyInput.addEventListener("change", function () {
            clampQty();
            syncItems();
          });
        }

        row.querySelectorAll(".sc-qty-btn").forEach(function (btn) {
          btn.addEventListener("click", function () {
            // Priority Placement is capped at qty 1 — buttons are disabled in HTML
            // but guard here too in case of programmatic changes
            if (row.dataset.type === "Priority Placement") return;
            var curr = parseInt(qtyInput.value, 10) || 1;
            qtyInput.value =
              btn.dataset.action === "inc"
                ? Math.min(curr + 1, 10)
                : Math.max(curr - 1, 1);
            syncItems();
          });
        });
      });

    // Organizer type radios
    document
      .querySelectorAll('input[name="org_type"]')
      .forEach(function (radio) {
        radio.addEventListener("change", function (e) {
          state.orgType = e.target.value;
          var isCorporate = state.orgType === "Corporate Entity";
          var warning = id("sc-corporate-warning");
          if (warning) warning.style.display = isCorporate ? "" : "none";
          var btnFreeSubmit = id("sc-btn-free-submit");
          var btnSchedule = id("sc-btn-to-schedule");
          if (btnFreeSubmit) btnFreeSubmit.style.display = isCorporate ? "none" : "";
          if (btnSchedule) btnSchedule.style.display = isCorporate ? "none" : "";
          // Hide/show everything after the org type field group
          var orgTypeGroup = id("sc-org-type-group");
          if (orgTypeGroup) {
            // Walk up to the parent .sc-field-group, then hide all subsequent siblings
            var orgFieldGroup = orgTypeGroup.closest(".sc-field-group");
            if (orgFieldGroup) {
              var sibling = orgFieldGroup.nextElementSibling;
              while (sibling) {
                if (isCorporate) {
                  sibling.style.display = "none";
                } else {
                  // Restore, but keep the error box hidden unless it has content.
                  // Skip .sc-sponsored-only elements — updateSubmissionTypeUI controls them.
                  if (sibling.id === "sc-step1-errors") {
                    sibling.style.display = "none";
                  } else if (!sibling.classList.contains("sc-sponsored-only")) {
                    sibling.style.display = "";
                  }
                }
                sibling = sibling.nextElementSibling;
              }
            }
          }
          updateSubmissionTypeUI();
          updatePriceDisplay();
        });
      });

    // Audience checkboxes
    function syncAudience() {
      state.audienceFor = Array.from(
        document.querySelectorAll('input[name="audience_for"]:checked'),
      ).map(function (c) {
        if (c.value === "Other") {
          var txt = id("sc-audience-other-text");
          var val = txt ? txt.value.trim() : "";
          // Drop the "Other:" entry entirely if nothing was typed
          return val ? "Other: " + val : "";
        }
        return c.value;
      }).filter(function (v) { return v; });
      saveStateSoon();
    }
    document
      .querySelectorAll('input[name="audience_for"]')
      .forEach(function (cb) {
        cb.addEventListener("change", syncAudience);
      });
    var otherText = id("sc-audience-other-text");
    var otherCheck = id("sc-audience-other-check");
    if (otherText) {
      // Auto-check the "Other" box as soon as the user starts typing.
      otherText.addEventListener("input", function () {
        if (otherCheck && otherText.value.trim() && !otherCheck.checked) {
          otherCheck.checked = true;
        }
        syncAudience();
      });
    }

    // Step 1 → Step 2 (sponsored)
    var btnToSchedule = id("sc-btn-to-schedule");
    if (btnToSchedule) {
      btnToSchedule.addEventListener("click", function () {
        var errors = validateStep1();
        if (errors.length) {
          showStep1Errors(errors);
          return;
        }
        showStep1Errors([]);

        // Build slot list from current selectedItems
        buildSlots();

        showStep(2);
        loadCalendly();
      });
    }

    // Step 1 → Free submit
    var btnFreeSubmit = id("sc-btn-free-submit");
    if (btnFreeSubmit) {
      btnFreeSubmit.addEventListener("click", submitFreeEvent);
    }

    // Back: Step 2 → Step 1
    var btnBack1 = id("sc-btn-back-to-1");
    if (btnBack1)
      btnBack1.addEventListener("click", function () {
        showStep(1);
      });

    // Continue to Review (shown after all slots booked)
    var btnContinueToReview = id("sc-btn-continue-to-review");
    if (btnContinueToReview)
      btnContinueToReview.addEventListener("click", function () {
        populateReview();
        showStep(3);
      });

    // Back: Step 3 → Step 2
    var btnBack2 = id("sc-btn-back-to-2");
    if (btnBack2)
      btnBack2.addEventListener("click", function () {
        showStep(2);
        // If all slots already booked, show Continue button rather than reloading Calendly
        var allBooked =
          state.calendlyBookings.length >= state.slots.length &&
          state.slots.length > 0;
        var continueBtn = id("sc-btn-continue-to-review");
        if (allBooked && continueBtn) {
          continueBtn.style.display = "";
        }
      });

    // Checkout
    var btnCheckout = id("sc-btn-checkout");
    if (btnCheckout)
      btnCheckout.addEventListener("click", addToCartAndCheckout);

    // ─── Extra UX listeners ───────────────────────────────────────────────
    // Live character counter for the description field
    var descInput = id("sc-event-description");
    if (descInput) descInput.addEventListener("input", updateDescriptionCounter);

    // Weekend hint when the user picks an event date
    var dateInput = id("sc-event-date");
    if (dateInput) dateInput.addEventListener("change", updateEventDateHint);

    // Email typo suggestion on blur
    var emailInput = id("sc-contact-email");
    if (emailInput) emailInput.addEventListener("blur", showEmailTypoSuggestion);

    // Normalize Instagram handle on blur (strip URLs, leading @, etc.)
    var igInput = id("sc-instagram-account");
    if (igInput) {
      igInput.addEventListener("blur", function () {
        var normalized = normalizeInstagram(igInput.value);
        igInput.value = normalized;
        state.instagramAccount = normalized;
        saveStateSoon();
      });
    }

    // Restore any previously-saved state before applying initial UI.
    // Skips file uploads and Calendly bookings (see PERSIST_KEYS).
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      if (saved && typeof saved === "object") {
        PERSIST_KEYS.forEach(function (k) {
          if (saved[k] !== undefined) state[k] = saved[k];
        });
        // Push state back into DOM
        var textFieldMap = {
          "sc-contact-name": "contactName",
          "sc-contact-email": "contactEmail",
          "sc-event-name": "eventName",
          "sc-event-date": "eventDate",
          "sc-venue-address": "venueAddress",
          "sc-organized-by": "organizedBy",
          "sc-event-description": "eventDescription",
          "sc-ticket-link": "ticketLink",
          "sc-instagram-account": "instagramAccount",
          "sc-org-connection": "orgConnection",
          "sc-market": "market",
        };
        Object.keys(textFieldMap).forEach(function (elId) {
          var el = id(elId);
          if (el && state[textFieldMap[elId]] != null) el.value = state[textFieldMap[elId]];
        });
        document.querySelectorAll('input[name="submission_type"]').forEach(function (r) {
          r.checked = r.value === state.submissionType;
        });
        document.querySelectorAll('input[name="event_is_free"]').forEach(function (r) {
          r.checked = r.value === state.eventIsFree;
        });
        document.querySelectorAll('input[name="org_type"]').forEach(function (r) {
          r.checked = r.value === state.orgType;
        });
        document.querySelectorAll('input[name="audience_for"]').forEach(function (cb) {
          var match = (state.audienceFor || []).some(function (v) {
            return v === cb.value || (cb.value === "Other" && /^Other:/.test(v));
          });
          cb.checked = match;
          if (cb.value === "Other" && match) {
            var otherEntry = (state.audienceFor || []).find(function (v) { return /^Other:/.test(v); });
            if (otherEntry) {
              var txt = id("sc-audience-other-text");
              if (txt) txt.value = otherEntry.replace(/^Other:\s*/, "");
            }
          }
        });
      }
    } catch (_) { /* ignore corrupt state */ }

    // Initial UI state
    updateSubmissionTypeUI();
    updatePriceDisplay();
    updateDescriptionCounter();
    updateEventDateHint();
    showStep(1);

    // Fetch live prices from Shopify product variants
    fetchProductPrices();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
